<div class="flex flex-col gap-10 h-full">
  <div class="flex items-start justify-between">
    <div class="flex flex-col gap-2">
      <ui-headline
        type="h24"
        mobile-type="h20"
        font-weight="semibold"
        text-color="neutrals-900"
        content="Filtros"
      ></ui-headline>
      <ui-paragraph
        type="p16"
        font-weight="regular"
        text-color="neutrals-700"
        content="Aplica filtros para visualizar resultados específicos"
      />
    </div>
    <button
      type="button"
      class="bg-transparent"
      aria-label="Cerrar"
      (click)="onClose()"
    >
      <ui-icon
        name="close"
        size="24"
        mobile-size="24"
        fill="neutrals-900"
      ></ui-icon>
    </button>
  </div>

  <div class="flex flex-col gap-6 flex-1">
    <div class="flex flex-col gap-2">
      <ui-paragraph
        type="p14"
        font-weight="regular"
        text-color="neutrals-600"
        content="Periodo de creación"
      />
      <div class="flex gap-4">
        <div class="relative w-[227px] h-12">
          <input
            type="text"
            readonly
            class="w-full h-12 rounded-xl border border-neutrals-400 bg-neutrals-0 px-3 pr-9"
            placeholder="DD/MM/YY"
            aria-label="Fecha inicial"
            [matDatepicker]="fromPicker"
            [max]="draftDateTo || maxDate"
            [value]="draftDateFrom"
            (click)="fromPicker.open()"
            (dateChange)="onDateFromPicked($event.value)"
          />
          <button
            type="button"
            class="absolute right-3 top-1/2 -translate-y-1/2"
            aria-label="Abrir calendario"
            (click)="fromPicker.open()"
          >
            <ui-icon
              name="calendar"
              size="20"
              mobile-size="20"
              fill="neutrals-600"
            ></ui-icon>
          </button>
          <mat-datepicker #fromPicker></mat-datepicker>
        </div>
        <div class="relative w-[227px] h-12">
          <input
            type="text"
            readonly
            class="w-full h-12 rounded-xl border border-neutrals-400 bg-neutrals-0 px-3 pr-9"
            placeholder="DD/MM/YY"
            aria-label="Fecha final"
            [matDatepicker]="toPicker"
            [min]="draftDateFrom"
            [max]="maxDate"
            [value]="draftDateTo"
            (click)="toPicker.open()"
            (dateChange)="onDateToPicked($event.value)"
          />
          <button
            type="button"
            class="absolute right-3 top-1/2 -translate-y-1/2"
            aria-label="Abrir calendario"
            (click)="toPicker.open()"
          >
            <ui-icon
              name="calendar"
              size="20"
              mobile-size="20"
              fill="neutrals-600"
            ></ui-icon>
          </button>
          <mat-datepicker #toPicker></mat-datepicker>
        </div>
      </div>
    </div>

    <div
      *ngIf="isLoadingFacets; else ferreteriaField"
      class="h-12 flex items-center"
    >
      <ui-paragraph
        type="p14"
        font-weight="regular"
        text-color="neutrals-600"
        content="Cargando ferreterías..."
      />
    </div>
    <ng-template #ferreteriaField>
      <digicem-filter-multi-select
        label="Ferretería"
        [options]="ferreteriaOptions"
        [selectedIds]="draftFerreteriaIds"
        (changed)="onFerreteriaChanged($event)"
      ></digicem-filter-multi-select>
    </ng-template>

    <div
      *ngIf="isLoadingFacets; else aliasField"
      class="h-12 flex items-center"
    >
      <ui-paragraph
        type="p14"
        font-weight="regular"
        text-color="neutrals-600"
        content="Cargando alias..."
      />
    </div>
    <ng-template #aliasField>
      <digicem-filter-multi-select
        label="Alias"
        [options]="aliasOptions"
        [selectedIds]="draftAliasIds"
        (changed)="onAliasChanged($event)"
      ></digicem-filter-multi-select>
    </ng-template>

    <!-- CA-13 — hidden entirely (not just empty) when the active date range
         has no Urgent/DueSoon records, per D-15. -->
    <div
      *ngIf="isLoadingFacets; else urgencyField"
      class="h-12 flex items-center"
    >
      <ui-paragraph
        type="p14"
        font-weight="regular"
        text-color="neutrals-600"
        content="Cargando plazos..."
      />
    </div>
    <ng-template #urgencyField>
      <digicem-filter-multi-select
        *ngIf="urgencyOptions.length"
        label="Plazo de vencimiento"
        [options]="urgencyOptions"
        [selectedIds]="draftUrgency"
        (changed)="onUrgencyChanged($event)"
      ></digicem-filter-multi-select>
    </ng-template>

    <ui-paragraph
      *ngIf="clientCapExceeded"
      type="p12"
      font-weight="regular"
      text-color="critical-300"
      content="Has alcanzado el límite de 100 clientes seleccionados."
    />
  </div>

  <div class="flex flex-col gap-2">
    <ui-button
      *ngIf="hasActiveDraftFilters"
      type="secondary"
      icon-preffix="delete"
      button-text="Borrar filtros"
      responsive="false"
      size="lg"
      [enabled]="true"
      [isLoading]="false"
      (click)="onClear()"
    ></ui-button>
    <ui-button
      type="primary"
      responsive="false"
      size="lg"
      button-text="Ver resultados"
      [enabled]="isSubmitEnabled"
      [isLoading]="false"
      (click)="onApply()"
    ></ui-button>
  </div>
</div>
